// @material-ui/icons

import DataUsage from "@material-ui/icons/DataUsage";
import Phone from "@material-ui/icons/Phone";
import Person from "@material-ui/icons/Person";
import AllInbox from "@material-ui/icons/AllInbox";
import VpnKey from "@material-ui/icons/VpnKey";
import ExitToApp from "@material-ui/icons/ExitToApp";
import ErrorIcon from "@material-ui/icons/Error";
import Payment from "@material-ui/icons/Payment";
import ListAlt from "@material-ui/icons/ListAlt";
import PostAddIcon from "@material-ui/icons/PostAdd";
import ContractIcon from "@material-ui/icons/Description";

import Important from "views/Important/ImportantPage.jsx";

import InternetDashboard from "views/Internet/DashboardPage.jsx";
import InternetUsage from "views/Internet/UsagePage.jsx";
import WiFi from "views/Internet/WiFiPage.jsx";
import InternetPackage from "views/Internet/PackagePage.jsx";
import InternetAdvancedSettings from "views/Internet/AdvancedSettingsPage.jsx";

import Phone911Profiles from "views/Phone/911ProfilesPage.jsx";
import PhoneBasicSettings from "views/Phone/BasicSettingsPage.jsx";
import PhoneCallHistory from "views/Phone/CallHistoryPage.jsx";
import PhoneInternationalAllowance from "views/Phone/InternationalAllowancePage.jsx";
import PhoneAdvancedSettings from "views/Phone/AdvancedSettingsPage.jsx";

import Documents from "views/Documents/Documents.jsx";
import Account from "views/Account/Account.jsx";
import ChangePassword from "views/ChangePassword/ChangePassword.jsx";
import AutoPayment from "views/AutoPayment/AutoPayment.jsx";
import DocumentUpload from "views/DocumentUpload/DocumentUpload.jsx";
import Signature from "views/Signature/Signature.jsx";
import Checklist from "views/Checklist/Checklist.jsx";
import PreinstallPackage from "views/Checklist/PreinstallPackage.jsx";
import PreinstallAdditionalInfo from "views/Checklist/PreinstallAdditionalInfo.jsx";
import PreinstallSchedule from "views/Checklist/PreinstallSchedule.jsx";
import {
  preinstallChecklistItems,
  getPreinstallChecklistItems,
} from "views/Checklist/checklistItems";
import Logout from "views/Logout/Logout.jsx";
import Offer from "views/Offer/Offer.jsx";
import Apibrowser from "views/Apibrowser/Apibrowser.jsx";

import ContactUS from "views/ContactUS/ContactUS.jsx";

import { addNewID } from "core-module/services/ids/actions";
import config from "config";
import * as api from "core-module/services/api";
import { ApiError } from "core-module/services/error";
import store from "store";
import TrafficDashboard from "../views/Internet/TrafficDashboard";

// core components/views for RTL layout
const baseLayout = config.MYACCOUNT.APP_PATH + "/user";
const blankLayout = config.MYACCOUNT.APP_PATH + "/will";

export const buildRoutes = async () => {
  const storeState = store.getState();

  if (storeState.services.ids.user !== "") {
    var userid = storeState.services.ids.user;
    var r = await api.get("user." + userid + "/serviceidentification");

    var contractResignType = null;
    var contractResign = false;
    var contractResponse = await api.get("user." + userid + "/contract");
    if (
      contractResponse &&
      "list" in contractResponse &&
      contractResponse.list.length > 0
    ) {
      contractResignType = contractResponse.list[0].contractResignType;
      contractResign = contractResponse.list[0].contractResign;
    }
  }

  const r2 = await api.get("me.1/accountwarning");

  let warningScreen = false;
  if (r2 && "list" in r2) {
    warningScreen = true;
  }
  var services = {
    hasBroadband: false,
    hasPhone: false,
    hasContactInfo: false,
    hasAr: false,
    hasPreinstall: false,
    hidedocuments: false,
    hasWiFi: false,
    hasRouter: false,
  };

  if (storeState.services.ids.user !== "" && r?.list?.[0] != null) {
    services = r.list[0];
  }

  store.dispatch(addNewID("hasPreinstall", services.hasPreinstall));

  let routes = [];

  let redirect = config.MYACCOUNT.APP_PATH + "/user/changepassword";

  if (services.hasPreinstall) {
    //Pre-install routes only !
    redirect = config.MYACCOUNT.APP_PATH + "/user/preinstallchecklist";
    const checklistResponse = api.requireApiSuccess(
      await api.get("user." + userid + "/preinstallchecklist"),
      "Your installation checklist could not be loaded. Please try again."
    );
    if (!checklistResponse.list?.[0]) {
      throw new ApiError(
        "Your installation checklist could not be loaded. Please try again."
      );
    }
    const checklistItems = getPreinstallChecklistItems(
      checklistResponse.list[0]
    );
    const checklistComponents = {
      "/preinstallpackage": PreinstallPackage,
      "/preinstalladditionalinfo": PreinstallAdditionalInfo,
      "/preinstallschedule": PreinstallSchedule,
      "/documentupload": DocumentUpload,
      "/autopayment": AutoPayment,
      "/contract": Signature,
    };

    routes.push({
      path: "/preinstallchecklist",
      name: "Checklist",
      icon: ListAlt,
      component: Checklist,
      layout: baseLayout,
    });
    preinstallChecklistItems.forEach((item) => {
      routes.push({
        path: item.path,
        name: item.title,
        icon: item.icon,
        component: checklistComponents[item.path],
        layout: baseLayout,
        sidebar: checklistItems.some((step) => step.path === item.path),
      });
    });

    return [redirect, [...routes, ...baseRoutes], warningScreen];
  }

  if (warningScreen) {
    routes.push({
      path: "/important",
      name: "Important",
      icon: ErrorIcon,
      component: Important,
      layout: baseLayout,
    });
  }

  if (services.hasBroadband) {
    redirect = config.MYACCOUNT.APP_PATH + "/user/dashboard";

    const broadbandViews = [
      {
        path: "/dashboard",
        name: "Dashboard",
        component: InternetDashboard,
        layout: baseLayout,
      },
    ];

    if (services.hasWiFi) {
      broadbandViews.push({
        path: "/wifi",
        name: "Wi-Fi",
        component: WiFi,
        layout: baseLayout,
      });
    }
    broadbandViews.push({
      path: "/trafficMonitor",
      name: "Traffic Monitor",
      component: TrafficDashboard,
      layout: baseLayout,
    });

    const broadbandRest = [
      {
        path: "/calendar",
        name: "Calendar",
        component: InternetUsage,
        layout: baseLayout,
      },
      {
        path: "/package",
        name: "Package",
        component: InternetPackage,
        layout: baseLayout,
      },
      {
        path: "/advancedsettings",
        name: "Advanced settings",
        component: InternetAdvancedSettings,
        layout: baseLayout,
      },
    ];

    broadbandViews.push(...broadbandRest);

    routes.push({
      collapse: true,
      name: "Internet",
      icon: DataUsage,
      state: "InternetCollapse",
      views: broadbandViews,
    });
  }

  if (services.hasPhone) {
    if (services.hasBroadband === false) {
      redirect = config.MYACCOUNT.APP_PATH + "/user/emergencyprofiles";
    }

    routes.push({
      collapse: true,
      name: "Phone",
      icon: Phone,
      state: "PhoneCollapse",
      views: [
        {
          path: "/emergencyprofiles",
          name: "911 Profiles",
          component: Phone911Profiles,
          layout: baseLayout,
        },
        {
          path: "/phonebasicsettings",
          name: "Basic Settings",
          component: PhoneBasicSettings,
          layout: baseLayout,
        },
        {
          path: "/phonecallshistory",
          name: "Calls History",
          component: PhoneCallHistory,
          layout: baseLayout,
        },
        {
          path: "/phoneinternationalallowance",
          name: "International Calls",
          component: PhoneInternationalAllowance,
          layout: baseLayout,
        },
        {
          path: "/phoneadvancedsettings",
          name: "Advanced Settings",
          component: PhoneAdvancedSettings,
          layout: baseLayout,
        },
      ],
    });
  }

  if (services.hasContactInfo) {
    if (services.hasBroadband === false && services.hasPhone === false) {
      redirect = config.MYACCOUNT.APP_PATH + "/user/account";
    }

    routes.push({
      path: "/account",
      name: "Account",
      icon: Person,
      component: Account,
      layout: baseLayout,
    });
    routes.push({
      path: "/documents",
      name: "Documents",
      icon: AllInbox,
      component: Documents,
      layout: baseLayout,
    });

    if (services.hasAr) {
      routes.push({
        path: "/autopayment",
        name: "Billing",
        icon: Payment,
        component: AutoPayment,
        layout: baseLayout,
      });
    }
  }

  if (warningScreen) {
    redirect = config.MYACCOUNT.APP_PATH + "/user/important";
  }

  let contractResignRoutes = [];
  if (contractResign) {
    if (contractResignType != "NEEDDOC_IDVERIFY") {
      redirect = config.MYACCOUNT.APP_PATH + "/user/contract";
      contractResignRoutes.push({
        path: "/contract",
        name: "Contract",
        icon: ContractIcon,
        component: Signature,
        layout: baseLayout,
      });
    } else {
      redirect = config.MYACCOUNT.APP_PATH + "/user/documentupload";
    }
    if (!services.hidedocuments) {
      contractResignRoutes.push({
        path: "/documentupload",
        name: "Add Documents",
        icon: PostAddIcon,
        component: DocumentUpload,
        layout: baseLayout,
      });
    }
  }

  const lastRoutes = [];
  if (userid === 26675 || userid === 41332) {
    lastRoutes.push({
      path: "/apibrowser",
      name: "",
      component: Apibrowser,
      layout: baseLayout,
    });
  }

  return [
    redirect,
    [...contractResignRoutes, ...routes, ...baseRoutes, ...lastRoutes],
    warningScreen,
  ];
};

const baseRoutes = [
  {
    name: "bottomItems",
    items: [
      {
        path: "/changepassword",
        name: "Change Password",
        icon: VpnKey,
        component: ChangePassword,
        layout: baseLayout,
      },
      {
        path: "/contactus",
        name: "Contact Us",
        icon: Phone,
        component: ContactUS,
        layout: baseLayout,
      },
      {
        path: "/logout",
        name: "Logout",
        icon: ExitToApp,
        component: Logout,
        layout: blankLayout,
      },
      {
        path: "/offer",
        name: "",
        component: Offer,
        layout: baseLayout,
      },
    ],
  },
];

export default baseRoutes;
